import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { IconType } from 'react-icons';
import { IoChevronDown, IoChevronForward } from 'react-icons/io5';

import { ROUTE_ADMIN } from 'src/utils/routes';
import { SidebarManagementGroupConfig } from 'src/utils/permissions';
import { useAdminPermissions } from 'src/hooks/useAdminPermissions';

import {
  StyledManagementChevron,
  StyledManagementGroup,
  StyledManagementLabel,
  StyledManagementSubItem,
  StyledManagementSubList,
  StyledManagementSubListInner,
  StyledManagementSubListWrap,
  StyledManagementToggle,
} from './styled';
import { StyledIcon } from './SidebarButton/styled';

type SidebarManagementGroupProps = {
  group: SidebarManagementGroupConfig;
  onNavigate?: () => void;
};

const SidebarManagementGroup: React.FC<SidebarManagementGroupProps> = ({ group, onNavigate }) => {
  const location = useLocation();
  const { can } = useAdminPermissions();
  const Icon = group.img as IconType;

  const visibleItems = group.items.filter((item) => can(item.permission));
  const isInSection = location.pathname.startsWith(`${ROUTE_ADMIN}/management`);
  const [expanded, setExpanded] = useState(isInSection);

  useEffect(() => {
    if (isInSection) setExpanded(true);
  }, [isInSection]);

  if (!can(group.permission) || !visibleItems.length) {
    return null;
  }

  return (
    <li>
      <StyledManagementGroup>
        <StyledManagementToggle
          type="button"
          $isActive={isInSection}
          onClick={() => setExpanded((v) => !v)}
          aria-expanded={expanded}
        >
          <StyledIcon>
            <Icon size={30} />
          </StyledIcon>
          <StyledManagementLabel title={group.text}>{group.text}</StyledManagementLabel>
          <StyledManagementChevron aria-hidden>
            {expanded ? <IoChevronDown size={12} /> : <IoChevronForward size={12} />}
          </StyledManagementChevron>
        </StyledManagementToggle>
        <StyledManagementSubListWrap $expanded={expanded}>
          <StyledManagementSubListInner>
            <StyledManagementSubList>
              {visibleItems.map((item) => {
                const path = `${ROUTE_ADMIN}/${item.url}`;
                const isActive = location.pathname === path;
                return (
                  <li key={item.text}>
                    <Link to={path} onClick={onNavigate}>
                      <StyledManagementSubItem $isActive={isActive}>{item.text}</StyledManagementSubItem>
                    </Link>
                  </li>
                );
              })}
            </StyledManagementSubList>
          </StyledManagementSubListInner>
        </StyledManagementSubListWrap>
      </StyledManagementGroup>
    </li>
  );
};

export default SidebarManagementGroup;
